/**
 * Sección "Mira cómo se ve por dentro": título + dos collages de páginas superpuestas.
 * Las imágenes están en Drive (hay que compartirlas con enlace para que se vean).
 */
const U = "https://lh3.googleusercontent.com/d/";
const COLLAGE_1 = U + "1SXT3obUxByoJXoJy1_NdJ5aDy66p6FcM";
const COLLAGE_2 = U + "1eMBzYfw2_21_2O8orT5XqKpWtabiF5Q8";

export const INSIDE_HTML = `<!-- POR DENTRO -->
<style>
.peek2 .peek2-grid{display:grid;gap:clamp(8px,2vw,22px);margin:34px auto 0;max-width:1100px}
.peek2 .peek2-grid img{width:100%;height:auto;display:block}
@media(max-width:560px){
  .peek2 .peek2-grid{margin-inline:-10px;margin-top:22px;gap:6px}
}
</style>
<section class="section peek2" id="por-dentro">
  <div class="wrap">
    <div class="center rv">
      <p class="eyebrow">Por dentro</p>
      <h2 style="margin-top:12px">Mira cómo se ve <em style="font-style:italic;font-weight:600;color:var(--clay)">por dentro</em></h2>
      <p class="lead" style="margin-top:14px">Material pensado para usarse, no para quedar guardado. Anota tu avance sin complicarte.</p>
    </div>
    <div class="peek2-grid rv">
      <img src="${COLLAGE_1}" alt="Páginas de la colección: ilustraciones, tablas y ejercicios" loading="lazy" decoding="async">
      <img src="${COLLAGE_2}" alt="Capítulos de la colección con fotos y guías paso a paso" loading="lazy" decoding="async">
    </div>
  </div>
</section>

`;

/** Esta sección ya no tiene pestañas; se deja la función para no tocar App.tsx. */
export function initInside(_root: HTMLElement): () => void {
  return () => undefined;
}
